import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import type {
  NotificationPreference,
  NotificationPreferenceUpdateInput,
} from '@vari-crew/schemas';
import { apiCall } from '@/lib/api';

type ListResponse = { data: NotificationPreference[] };

const KEY = ['notification-preferences'] as const;

export function useNotificationPreferences() {
  return useQuery<ListResponse>({
    queryKey: KEY,
    queryFn: () => apiCall<ListResponse>('/me/notification-preferences'),
  });
}

export function useUpdateNotificationPreferences() {
  const qc = useQueryClient();
  return useMutation<ListResponse, Error, NotificationPreferenceUpdateInput[]>({
    mutationFn: (updates) =>
      apiCall<ListResponse>('/me/notification-preferences', {
        method: 'PUT',
        body: { updates },
      }),
    onSuccess: (data) => {
      qc.setQueryData(KEY, data);
    },
  });
}
